exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pagetitle[data-v-4047f110]{font-size:18px;color:#000}.warp50[data-v-4047f110]{padding-top:10px;width:100%}.evaimg[data-v-4047f110]{width:100px;height:100px;float:left;margin-right:10px;margin-bottom:10px}.complainBut[data-v-4047f110]{margin-left:50%}.el-dialog__body .el-form-item[data-v-4047f110]{margin-bottom:0}.el-dialog__body .line[data-v-4047f110]{margin-bottom:5px}.mb20[data-v-4047f110]{margin-bottom:0}.noteBox[data-v-4047f110]{margin-left:70px;margin-top:5px}.noteCircle[data-v-4047f110]{width:20px;height:20px;border-radius:50%;border:1px solid #000;text-align:center;display:inline-block;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-4047f110","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/views/aftersale/refund/list.vue
// module id = 473
// module chunks = 0